/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryBasicEntryRequest } from './RevisdomAPIViewModelsEntryBasicEntryRequest';
import {
    RevisdomAPIViewModelsEntryBasicEntryRequestFromJSON,
    RevisdomAPIViewModelsEntryBasicEntryRequestFromJSONTyped,
    RevisdomAPIViewModelsEntryBasicEntryRequestToJSON,
    RevisdomAPIViewModelsEntryBasicEntryRequestToJSONTyped,
} from './RevisdomAPIViewModelsEntryBasicEntryRequest';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryDeleteEntriesRequest
 */
export interface RevisdomAPIViewModelsEntryDeleteEntriesRequest {
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsEntryBasicEntryRequest>}
     * @memberof RevisdomAPIViewModelsEntryDeleteEntriesRequest
     */
    entries?: Array<RevisdomAPIViewModelsEntryBasicEntryRequest> | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryDeleteEntriesRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryDeleteEntriesRequest(value: object): value is RevisdomAPIViewModelsEntryDeleteEntriesRequest {
    return true;
}

export function RevisdomAPIViewModelsEntryDeleteEntriesRequestFromJSON(json: any): RevisdomAPIViewModelsEntryDeleteEntriesRequest {
    return RevisdomAPIViewModelsEntryDeleteEntriesRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDeleteEntriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryDeleteEntriesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': json['entries'] == null ? undefined : ((json['entries'] as Array<any>).map(RevisdomAPIViewModelsEntryBasicEntryRequestFromJSON)),
    };
}

export function RevisdomAPIViewModelsEntryDeleteEntriesRequestToJSON(json: any): RevisdomAPIViewModelsEntryDeleteEntriesRequest {
    return RevisdomAPIViewModelsEntryDeleteEntriesRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDeleteEntriesRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryDeleteEntriesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entries': value['entries'] == null ? undefined : ((value['entries'] as Array<any>).map(RevisdomAPIViewModelsEntryBasicEntryRequestToJSON)),
    };
}

